import { render } from "./ProfileImageInput.vue?vue&type=template&id=b553055e&scoped=true"
import script from "./ProfileImageInput.vue?vue&type=script&lang=js"
export * from "./ProfileImageInput.vue?vue&type=script&lang=js"

import "./ProfileImageInput.vue?vue&type=style&index=0&id=b553055e&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b553055e"]])

export default __exports__